<template>
    <div v-if="ready">
        <form
            class="form-horizontal fr-absolute"
            enctype="multipart/form-data"
            @submit.prevent="store"
            @keydown="form.errors.clear($event.target.name)"
            novalidate
            autocomplete="off"
        >

            <div class="row">
                <div class="col-s12 col-md-3 col-xl-2">
                    <label class="form-control-label col-form-label">{{ uLang('app.name') }}:</label>
                </div>
                <div class="col-s12 col-md-9 col-xl-10">
                    <span>{{ relation.full_name }}</span>
                </div>
            </div>

            <backend-select :error="form.errors.get('client_id')" :value="field('client_id')" return="id" required
                            v-model="form.client_id" name="client_id" label="client"
                            :route="route('organisations.index', {type: ['client']})"/>

            <form-select :error="form.errors.get('trajectory_project_id')" :disabled="!form.client_id" required
                         :value="field('trajectory_project_id')" v-model="trajectory_project" :options="trajectory_projects"
                         name="trajectory_project_id" label="trajectory_project" track-by="id" :loading="fields_loading.trajectory_projects"/>

            <form-select :error="form.errors.get('trajectory_id')" :disabled="!form.trajectory_project_id"
                         :value="field('trajectory_id')" v-model="trajectory" :options="trajectories" required
                         name="trajectory_id" label="trajectory" track-by="id" :loading="fields_loading.trajectories"/>

            <form-date-picker :form="form" name="trajectory_start_date" label="start_date" required/>

            <form-date-picker :form="form" name="trajectory_end_date" label="end_date" required/>

            <!-- :disabled="!form.trajectory_project_id || (trajectory_project && !!trajectory_project.contact_id)" -->
            <form-select
                :error="form.errors.get('contact_id')"
                object-name-key="display_name"
                track-by="id"
                :value="field('contact_id')"
                v-model="contact"
                required
                :options="contacts"
                name="contact_id"
                label="enrolment_contact_client"
                :loading="fields_loading.contacts"
                autocomplete="off"
            />

            <form-select
                :error="form.errors.get('reporting_person_id')"
                object-name-key="display_name"
                track-by="id"
                required
                :value="field('reporting_person_id')"
                v-model="reporting_person"
                :options="reporting_persons"
                name="reporting_person_id"
                label="enrolment_reporting_person"
                :loading="fields_loading.reporting_persons"
            />

            <form-select
                v-model="casemanager"
                :value="field('casemanager_id')"
                track-by="id"
                object-name-key="full_name"
                :error="form.errors.get('casemanager_id')"
                :options="casemanagers"
                name="casemanager_id"
                label="enrolment_casemanager"
                :loading="fields_loading.casemanagers"
                autocomplete="off"
                :disabled="!form.trajectory_id"
            />

            <trajectory-manager-select
                track-by="id"
                v-model="trajectory_manager"
                :error="form.errors.get('trajectory_manager_id')"
                :options="updated_trajectory_managers"
                name="trajectory_manager_id"
                label="enrolment_trajectory_manager"
                :candidate="relation.id"
                :loading="fields_loading.trajectory_managers"
                :disabled="!form.trajectory_id"
            />

            <form-input :form="form" name="customer_number_according_to_client"/>

            <backend-select :error="form.errors.get('receives_lead_person_id')" label="receives_lead_person"
                            :value="field('receives_lead_person_id')" v-model="receives_lead_person" track-by="id"
                            name="receives_lead_person_id" :route="route('relations.index', {not_type: ['candidate']})"
                            object-name-key="full_name"/>

            <backend-select :error="form.errors.get('receives_lead_organisation_id')" label="receives_lead_organisation"
                            :value="field('receives_lead_organisation_id')" name="receives_lead_organisation_id"
                            v-model="form.receives_lead_organisation_id" track-by="id" return="id"
                            :route="route('organisations.index', {not_type: ['candidate']})"/>

            <backend-select :error="form.errors.get('receives_acquisition_person_id')" name="receives_acquisition_person_id"
                            :value="field('receives_acquisition_person_id')" label="receives_acquisition_person" track-by="id"
                            v-model="receives_acquisition_person" :route="route('relations.index', {type: ['coach']})"
                            object-name-key="full_name"/>

            <backend-select :error="form.errors.get('receives_acquisition_organisation_id')" track-by="id" return="id"
                            :value="field('receives_acquisition_organisation_id')"  name="receives_acquisition_organisation_id"
                            :route="route('organisations.index', {type: ['coach']})" label="receives_acquisition_organisation"
                            v-model="form.receives_acquisition_organisation_id"/>

            <form-input :form="form" name="trajectory_price_excluding_vat" type="number" step="0.01" min="0"
                        :disabled="!trajectory || !trajectory.variable_trajectory_prices"
                        :required="trajectory && !!trajectory.variable_trajectory_prices"/>

            <div class="form-group fr-absolute">
                <input :disabled="form.busy" type="submit" class="btn btn-brand"
                       :value="uLang('app.enrol')"/>
            </div>
        </form>
    </div>
</template>

<script>
    import Form from '~/Form/Form';
    import FormMixin from '~/mixins/form';
    import { SuccessfullyStoredAlert, SuccessfullyUpdatedAlert } from "~/Swals";
    import { TrajectoryManagerSelect } from '~/Form/elements'

    export default {
        name: 'form-trajectory-enrolment',
        mixins: [FormMixin],
        components: {
            TrajectoryManagerSelect,
        },

        props: {
            id: {
                required: false,
            },
            relation: {
                required: false,
                type: Object,
            },

            // For duplicate action
            prefill: {
                type: Object,
                required: false,
                default: null,
            },
        },

        data() {
            return {
                entity: 'trajectory-enrolment',
                form: new Form({
                    client_id: null,
                    trajectory_project_id: null,
                    trajectory_id: null,
                    contact_id: null,
                    reporting_person_id: null,
                    trajectory_manager_id: null,
                    casemanager_id: null,
                    trajectory_start_date: '',
                    trajectory_end_date: '',
                    customer_number_according_to_client: '',
                    receives_lead_person_id: null,
                    receives_lead_organisation_id: null,
                    receives_acquisition_person_id: null,
                    receives_acquisition_organisation_id: null,
                    trajectory_price_excluding_vat: '',
                    duplicate_from_id: null,
                }),
                trajectory_project: null,
                trajectory_projects: [],
                trajectory: null,
                trajectories: [],
                contact: null,
                contacts: [],
                reporting_person: null,
                reporting_persons: [],
                trajectory_manager: null,
                trajectory_managers: [],
                casemanager: null,
                casemanagers: [],
                receives_lead_person: null,
                receives_acquisition_person: null,
                fields_loading: {
                    trajectory_projects: false,
                    trajectories: false,
                    contacts: false,
                    reporting_persons: false,
                    trajectory_managers: false,
                    casemanagers: false,
                },
                first_time_edited: {
                    trajectory_projects: false,
                    trajectories: false,
                    contacts: false,
                    reporting_persons: false,
                    trajectory_managers: false,
                },
                // Skip watcher resets while the edit form restores saved people/projects.
                hydrating: false,
                swal: false,
            };
        },

        created() {
            this.$on('afterStore', this.afterStore);
            this.$on('afterUpdate', this.afterUpdate);
            this.$on('afterRetrieve', this.afterRetrieve);

            if (this.isUpdate()) {
                this.hydrating = true;
            }

            if (!this.isUpdate() && this.prefill) {
                // set raw ids so watchers/validations see them immediately
                Object.assign(this.form, {
                    client_id: this.prefill.client_id ?? null,
                    trajectory_project_id: this.prefill.trajectory_project_id ?? null,
                    trajectory_id: this.prefill.trajectory_id ?? null,
                    contact_id: this.prefill.contact_id ?? null,
                    reporting_person_id: this.prefill.reporting_person_id ?? null,
                    trajectory_manager_id: this.prefill.trajectory_manager_id ?? null,
                    casemanager_id: this.prefill.casemanager_id ?? null,
                    customer_number_according_to_client: this.prefill.customer_number_according_to_client ?? '',
                    receives_lead_person_id: this.prefill.receives_lead_person_id ?? null,
                    receives_lead_organisation_id: this.prefill.receives_lead_organisation_id ?? null,
                    receives_acquisition_person_id: this.prefill.receives_acquisition_person_id ?? null,
                    receives_acquisition_organisation_id: this.prefill.receives_acquisition_organisation_id ?? null,
                    trajectory_price_excluding_vat: this.prefill.trajectory_price_excluding_vat ?? '',
                    trajectory_start_date: '',
                    trajectory_end_date: '',
                    duplicate_from_id: this.prefill.duplicate_from_id ?? null,
                });

                // then run the proper async chain that sets the *objects* in order
                this.$nextTick(() => this.hydrateFromPrefill(this.prefill));
            }
        },

        methods: {
            afterRetrieve(data) {
                if (this.isUpdate()) {
                    this.receives_lead_person = data.receives_lead_person;
                    this.receives_acquisition_person = data.receives_acquisition_person;
                    this.hydrateUpdateSelections(data);
                }
            },

            findOptionById(options, id) {
                if (id == null || !Array.isArray(options)) {
                    return null;
                }

                return options.find(option => option && String(option.id) === String(id)) || null;
            },

            withDisplayName(person) {
                if (!person) {
                    return null;
                }

                if (person.display_name) {
                    return person;
                }

                const organisationName = person.organisation && person.organisation.name;

                return {
                    ...person,
                    display_name: organisationName
                        ? `${person.full_name} (${organisationName})`
                        : person.full_name,
                };
            },

            ensureOptionInList(listName, option) {
                if (!option || this.findOptionById(this[listName], option.id)) {
                    return;
                }

                this[listName] = [option, ...this[listName]];
            },

            applySavedPerson(listName, field, savedId, savedPerson) {
                const fromList = this.findOptionById(this[listName], savedId);

                if (fromList) {
                    this[field] = fromList;
                    return;
                }

                const fallback = this.withDisplayName(savedPerson);
                this[field] = fallback;
                this.ensureOptionInList(listName, fallback);
            },

            async hydrateUpdateSelections(data) {
                try {
                    if (!data.client_id) {
                        return;
                    }

                    await Promise.all([
                        this.retrieveContacts(data.client_id),
                        this.retrieveReportingPersons(data.client_id),
                        this.retrieveTrajectoryProjects(data.client_id),
                    ]);

                    this.trajectory_project = this.findOptionById(
                        this.trajectory_projects,
                        data.trajectory_project_id
                    ) || data.trajectory_project || null;

                    if (this.trajectory_project) {
                        await this.retrieveTrajectories(this.trajectory_project.id);
                        this.trajectory = this.findOptionById(
                            this.trajectories,
                            data.trajectory_id
                        ) || data.trajectory || null;
                    }

                    this.applySavedPerson('contacts', 'contact', data.contact_id, data.contact);
                    this.applySavedPerson(
                        'reporting_persons',
                        'reporting_person',
                        data.reporting_person_id,
                        data.reporting_person
                    );

                    if (this.trajectory) {
                        await Promise.all([
                            this.retrieveTrajectoryManagers(
                                this.trajectory.trajectory_project_id,
                                this.trajectory.id
                            ),
                            this.retrieveCasemanagers(this.trajectory.id),
                        ]);

                        this.casemanager = this.findOptionById(
                            this.casemanagers,
                            data.casemanager_id
                        ) || data.casemanager || null;
                        this.trajectory_manager = this.findOptionById(
                            this.trajectory_managers,
                            data.trajectory_manager_id
                        ) || data.trajectory_manager || null;
                    }

                    // Let queued watchers see hydrating=true so they do not wipe saved values.
                    await this.$nextTick();
                } finally {
                    this.hydrating = false;
                }
            },

            afterStore(data) {
                new SuccessfullyStoredAlert({
                    entity: this.lang('app.trajectory_enrolment'),
                    className: 'swal-wide',
                }).show()
                    .then((buttonPressed) => {
                        if (buttonPressed === 'create_another') {
                            // Form mixin clears fields already
                        } else if (buttonPressed === 'show') {
                            this.$router.push({name: 'admin.relations.trajectory-enrolments.view', params: {
                                    relationId: this.relation.id,
                                    trajectoryEnrolmentId: data.id,
                                }});
                        }
                    });
            },

            afterUpdate(data) {
                new SuccessfullyUpdatedAlert({entity: this.lang('app.trajectory_enrolment')}).show()
                    .then(() => {
                        this.$router.push({name: 'admin.relations.trajectory-enrolments.view', params: {
                                relationId: this.relation.id,
                                trajectoryEnrolmentId: this.id,
                            }});
                    });
            },

            loadValueOnFirstTime(field) {
                if (this.hydrating) {
                    return;
                }

                if (this.isUpdate() && !this.first_time_edited[field]) {
                    this[field] = this.retrieved[field];
                    this.first_time_edited[field] = true;
                }
            },

            async retrieveTrajectoryProjects(organisationId) {
                this.fields_loading.trajectory_projects = true;
                const { data } = await window.axios.get(route('organisations.trajectory-projects.index', {organisation: organisationId}));
                this.trajectory_projects = data;
                this.fields_loading.trajectory_projects = false;

                this.loadValueOnFirstTime('trajectory_project');
            },

            async retrieveTrajectories(trajectoryProjectId) {
                this.fields_loading.trajectories = true;
                const { data } = await window.axios.get(route('trajectory-projects.trajectories.index', {trajectory_project: trajectoryProjectId}));
                this.trajectories = data;
                this.fields_loading.trajectories = false;

                this.loadValueOnFirstTime('trajectory');
            },

            async retrieveContacts(organisationId) {
                this.fields_loading.contacts = true;
                const { data } = await window.axios.get(route('organisations.relations.index', {organisation: organisationId, role: ['contact']}));
                this.contacts = data;
                this.form.errors.clear('contact_id')
                if(!this.contacts[0]){
                  this.form.errors.record( {
                    contact_id :
                    { 0 : uLang('app.no_project_contact_available')}
                  } );
                }
                this.fields_loading.contacts = false;
                this.loadValueOnFirstTime('contact');
            },

            async retrieveReportingPersons(organisationId) {
                this.fields_loading.reporting_persons = true;
                const { data } = await window.axios.get(route('organisations.relations.index', {organisation: organisationId, role: ['contact']}));
                this.reporting_persons = data;
                this.fields_loading.reporting_persons = false;

                this.loadValueOnFirstTime('reporting_person');
            },

            async retrieveTrajectoryManagers(trajectoryProjectId, trajectoryId) {
                this.fields_loading.trajectory_managers = true;
                const { data } = await window.axios.get(
                    route('trajectory-projects.trajectories.trajectory-managers.index', {
                        trajectory_project: trajectoryProjectId,
                        trajectory: trajectoryId,
                        candidate: this.relation.id
                    }))
                ;
                this.trajectory_managers = data;

                this.loadValueOnFirstTime('trajectory_manager');
            },

            async retrieveCasemanagers(trajectoryId) {
                this.fields_loading.casemanagers = true;

                const { data } = await window.axios.get(
                    route('trajectories.casemanagers.index', {
                        trajectory: trajectoryId,
                    }))
                ;
                this.casemanagers = data;

                this.fields_loading.casemanagers = false;

                this.loadValueOnFirstTime('casemanager');
            },

            async hydrateFromPrefill(p) {
                // 1) client
                if (p.client_id) {
                    this.form.client_id = p.client_id;
                    await Promise.all([
                        this.retrieveContacts(p.client_id),
                        this.retrieveReportingPersons(p.client_id),
                        this.retrieveTrajectoryProjects(p.client_id),
                    ]);
                }

                // 2) trajectory project (object)
                if (p.trajectory_project_id && this.trajectory_projects.length) {
                    this.trajectory_project =
                        this.findOptionById(this.trajectory_projects, p.trajectory_project_id);

                    // 3) trajectories for that project
                    if (this.trajectory_project) {
                        await this.retrieveTrajectories(this.trajectory_project.id);
                    }
                }

                // 4) trajectory (object)
                if (p.trajectory_id && this.trajectories.length) {
                    this.trajectory = this.findOptionById(this.trajectories, p.trajectory_id);

                    // 5) managers + casemanagers for that trajectory
                    if (this.trajectory) {
                        await Promise.all([
                        this.retrieveTrajectoryManagers(this.trajectory.trajectory_project_id, this.trajectory.id),
                        this.retrieveCasemanagers(this.trajectory.id),
                        ]);
                    }
                }

                // 6) set the people objects (only if the lists have them)
                this.applySavedPerson('contacts', 'contact', p.contact_id, null);
                this.applySavedPerson('reporting_persons', 'reporting_person', p.reporting_person_id, null);
                this.casemanager = this.findOptionById(this.casemanagers, p.casemanager_id);
                this.trajectory_manager = this.findOptionById(this.trajectory_managers, p.trajectory_manager_id);

                // 7) set receives_* (these backend-selects usually accept just the id)
                this.form.receives_lead_person_id = p.receives_lead_person_id ?? null;
                this.form.receives_lead_organisation_id = p.receives_lead_organisation_id ?? null;
                this.form.receives_acquisition_person_id = p.receives_acquisition_person_id ?? null;
                this.form.receives_acquisition_organisation_id = p.receives_acquisition_organisation_id ?? null;

                // 8) other fields + clear dates
                this.form.customer_number_according_to_client = p.customer_number_according_to_client ?? '';
                this.form.trajectory_price_excluding_vat     = p.trajectory_price_excluding_vat ?? '';
                this.form.trajectory_start_date              = '';
                this.form.trajectory_end_date                = '';
            },
        },

        computed: {
            // Loops over the trajectory managers, and sets them to unavailable if the begin traject period falls
            // Into their unavailable period, and disabled the option
            updated_trajectory_managers() {
                let updated_trajectory_managers = this.trajectory_managers.map((trajectory_manager) => {
                    if(trajectory_manager.unavailable_period_start && trajectory_manager.unavailable_period_end) {
                        let start = moment(trajectory_manager.unavailable_period_start)
                        let end = moment(trajectory_manager.unavailable_period_end)
                        let trajectory_start = moment(this.form.trajectory_start_date)

                        trajectory_manager.unavailable = trajectory_start.isAfter(start) && trajectory_start.isBefore(end)
                    }
                    trajectory_manager.$isDisabled = trajectory_manager.unavailable || trajectory_manager.max_trajectories_reached
                    return trajectory_manager
                })
                this.fields_loading.trajectory_managers = false;
                return updated_trajectory_managers
            },

            client_id() {
                return this.form.client_id;
            },

            receives_lead_organisation_id() {
                return this.form.receives_lead_organisation_id;
            },

            receives_acquisition_organisation_id() {
                return this.form.receives_acquisition_organisation_id;
            },
        },

        watch: {
            client_id(newVal, oldVal) {
                if (newVal === oldVal || this.hydrating)
                    return;

                // Set fields dependent on client_id to null
                this.trajectory_project = null;
                this.trajectory = null;
                this.contact = null;
                this.reporting_person = null;

                if (newVal !== null) {
                    this.retrieveContacts(newVal);
                    this.retrieveReportingPersons(newVal);
                    // Keep this down here so that the others can load first, before the user can select a project
                    // Else setting the default value will fail
                    this.retrieveTrajectoryProjects(newVal);
                } else {
                    this.trajectory_projects = [];
                    this.contacts = [];
                    this.reporting_persons = [];
                }
            },

            trajectory_project(newVal, oldVal) {
                if (newVal === oldVal || this.hydrating) {
                    return;
                }

                // Set fields dependent on trajectory_project to null
                this.trajectory = null;

                if (newVal !== null) {
                    // If a new value is set, we set the form value
                    // and set values of other fields to that of the project
                    this.form.trajectory_project_id = newVal.id;
                    this.retrieveTrajectories(newVal.id);

                    if (newVal.contact_id) {
                        this.contact = this.findOptionById(this.contacts, newVal.contact_id);
                    }
                } else {
                    // Set fields dependent on project to null;
                    this.form.trajectory_project_id = null;
                    this.contact = null;
                }
            },

            trajectory(newVal, oldVal) {
                if (newVal === oldVal || this.hydrating) {
                    return;
                }

                if (newVal !== null) {
                    this.form.trajectory_id = newVal.id;
                    this.retrieveTrajectoryManagers(newVal.trajectory_project_id, newVal.id);
                    this.retrieveCasemanagers(newVal.id);

                    if (newVal.reporting_person_id) {
                        const reportingPerson = this.findOptionById(
                            this.reporting_persons,
                            newVal.reporting_person_id
                        );

                        if (reportingPerson) {
                            this.reporting_person = reportingPerson;
                        } else if (!this.isUpdate()) {
                            this.reporting_person = null;
                        }
                    }
                } else {
                    this.form.trajectory_id = null;
                    this.trajectory_manager = null;
                    this.reporting_person = null;
                }
            },

            contact(newVal, oldVal) {
                if (newVal !== null) {
                    this.form.contact_id = newVal.id;
                } else {
                    this.form.contact_id = null;
                }
            },

            reporting_person(newVal, oldVal) {
                if (newVal !== null) {
                    this.form.reporting_person_id = newVal.id;
                } else {
                    this.form.reporting_person_id = null;
                }
            },

            trajectory_manager(newVal, oldVal) {
                if (newVal !== null) {
                    this.form.trajectory_manager_id = newVal.id;
                } else {
                    this.form.trajectory_manager_id = null;
                }
            },

            casemanager(newVal, oldVal) {
                if (newVal !== null) {
                    this.form.casemanager_id = newVal.id;
                } else {
                    this.form.casemanager_id = null;
                }
            },

            receives_lead_person(newVal, oldVal) {
                if (newVal !== null) {
                    this.form.receives_lead_person_id = newVal.id;
                    this.form.receives_lead_organisation_id = newVal.organisation_id;
                } else {
                    this.form.receives_lead_person_id = null;
                }
            },

            receives_lead_organisation_id(newVal, oldVal) {
                if (newVal === null || (this.receives_lead_person !== null && this.receives_lead_person.organisation_id !== newVal)) {
                    this.receives_lead_person = null;
                }
            },

            receives_acquisition_person(newVal, oldVal) {
                if (newVal !== null) {
                    this.form.receives_acquisition_person_id = newVal.id;
                    this.form.receives_acquisition_organisation_id = newVal.organisation_id;
                } else {
                    this.form.receives_acquisition_person_id = null;
                }
            },

            receives_acquisition_organisation_id(newVal, oldVal) {
                if (newVal === null || (this.receives_acquisition_person !== null && this.receives_acquisition_person.organisation_id !== newVal)) {
                    this.receives_acquisition_person = null;
                }
            },
        },
    };
</script>
